import React from 'react'
import { Link } from 'react-router-dom'

import classnames from 'classnames'

import {
  TOAST_LOCAL_CATERING_PATH,
  TOAST_LOCAL_CATERING_SEARCH_PATH,
  TOAST_LOCAL_PATH,
  TOAST_LOCAL_SEARCH_PATH,
  TOAST_LOCAL_VENUES_PATH,
  TOAST_LOCAL_VENUES_SEARCH_PATH
} from 'src/public/js/siteUtilities'

import Image from 'shared/components/common/Image'
import { useFlags } from 'shared/components/common/feature_flags/useFlags'

import SearchBar from 'public/components/toast_local/common/search_bar/SearchBar'

import { SplashPageSearchMode } from './Splash'

import { t } from 'src/translations'

const getSearchPathForSplashMode = (mode: SplashPageSearchMode): string => {
  switch (mode) {
    case 'CATERING':
      return TOAST_LOCAL_CATERING_SEARCH_PATH
    case 'VENUES':
      return TOAST_LOCAL_VENUES_SEARCH_PATH
    case 'RESTAURANTS':
    default:
      return TOAST_LOCAL_SEARCH_PATH
  }
}

const LEFT_IMAGE =
  'https://cdn.toasttab.com/static/8a5a9a2b7b1ece5c098deab72591d9a2ef643e75/projects/new-ventures/catering/toast-local-buildings-1.png'
const RIGHT_IMAGE =
  'https://cdn.toasttab.com/static/8a5a9a2b7b1ece5c098deab72591d9a2ef643e75/projects/new-ventures/catering/toast-local-buildings-2.png'

const Hero = ({ mode }: { mode: SplashPageSearchMode }) => {
  const { nvsMarketplaceLeadForms } = useFlags()

  return (
    <div className='heroContainer'>
      <div className='heroContent'>
        <Image
          className='heroImage'
          src={LEFT_IMAGE}
          alt={t('hero.restaurant-buildings')}
        />
        <div className='heroCenterContent'>
          <h1>{t('hero.order-directly')}</h1>
          <div className='heroButtonsContainer'>
            <div
              className={classnames('heroSearchModeButton', {
                heroButtonSelected: mode === 'RESTAURANTS'
              })}
              data-testid='hero-button-restaurants'
            >
              <Link to={TOAST_LOCAL_PATH}>
                <div className='heroSearchModeText'>
                  {t('hero.restaurants')}
                </div>
              </Link>
            </div>
            <div
              className={classnames('heroSearchModeButton', {
                heroButtonSelected: mode === 'CATERING'
              })}
              data-testid='hero-button-catering'
            >
              <Link to={TOAST_LOCAL_CATERING_PATH}>
                <div className='heroSearchModeText'>{t('hero.catering')}</div>
              </Link>
            </div>
            {nvsMarketplaceLeadForms && (
              <div
                className={classnames('heroSearchModeButton', {
                  heroButtonSelected: mode === 'VENUES'
                })}
                data-testid='hero-button-venues'
              >
                <Link to={TOAST_LOCAL_VENUES_PATH}>
                  <div className='heroSearchModeText'>{t('hero.venues')}</div>
                </Link>
              </div>
            )}
          </div>
          <div className='heroSearchBarContainer'>
            <SearchBar
              className='full heroSearchBar'
              searchMode='location'
              searchPath={getSearchPathForSplashMode(mode)}
            />
          </div>
        </div>
        <Image
          className='heroImage'
          src={RIGHT_IMAGE}
          alt={t('hero.restaurant-buildings')}
        />
      </div>
    </div>
  )
}

export default Hero
